'use strict';

var FlightAnalysisToggleDirective = function FlightAnalysisToggleDirective($rootScope) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/flight-analysis-toggle.html'),
    scope: {
      screenState: '='
    },
    controller: 'FlightAnalysisToggleController',
    link: function link(scope) {
      scope.toggleFlightAnalysisMode = function (mode) {
        scope.screenState.flightAnalysisMode.visible = mode === 'flight-analysis';
        scope.screenState.flightManagementMode.visible = mode === 'flight-management';
        $rootScope.$broadcast('workflow-tab-changed', mode);
      };
    }
  };
};
FlightAnalysisToggleDirective.$inject = ['$rootScope'];
module.exports = FlightAnalysisToggleDirective;